// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ApplyConfigurationCard_CheckoutConfigFragmentDoc } from '../components/ApplyConfigurationCard.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type VersionUpdateStepQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
  structureId: Types.Scalars['ID']['input'];
}>;


export type VersionUpdateStepQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, configChange?: { __typename?: 'ChangeEventConfigChange', id: string, original: { __typename?: 'CheckoutConfig', id: string, updatedAt: Types.Scalars['DateTime']['input'], config: { __typename?: 'CheckoutConfigSide', name: string, exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined } }, target?: { __typename?: 'CheckoutConfig', id: string, updatedAt: Types.Scalars['DateTime']['input'], config: { __typename?: 'CheckoutConfigSide', name: string, exteriorOptionNames: Array<string>, interiorOptionNames: Array<string>, productOffering?: { __typename?: 'ProductOffering', id: string, name: string, code?: string | null | undefined, coverAsset?: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, aggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string } | null | undefined } } | null | undefined } | null | undefined } };


export const VersionUpdateStepDocument = gql`
    query VersionUpdateStep($changeEventId: ID!, $structureId: ID!) {
  changeEvent(id: $changeEventId) {
    id
    configChange {
      id
      original {
        ...ApplyConfigurationCard_CheckoutConfig
      }
      target {
        ...ApplyConfigurationCard_CheckoutConfig
      }
    }
  }
}
    ${ApplyConfigurationCard_CheckoutConfigFragmentDoc}`;

/**
 * __useVersionUpdateStepQuery__
 *
 * To run a query within a React component, call `useVersionUpdateStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useVersionUpdateStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVersionUpdateStepQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useVersionUpdateStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VersionUpdateStepQuery, VersionUpdateStepQueryVariables> & ({ variables: VersionUpdateStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>(VersionUpdateStepDocument, options);
      }
export function useVersionUpdateStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>(VersionUpdateStepDocument, options);
        }
// @ts-ignore
export function useVersionUpdateStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>;
export function useVersionUpdateStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VersionUpdateStepQuery | undefined, VersionUpdateStepQueryVariables>;
export function useVersionUpdateStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>(VersionUpdateStepDocument, options);
        }
export type VersionUpdateStepQueryHookResult = ReturnType<typeof useVersionUpdateStepQuery>;
export type VersionUpdateStepLazyQueryHookResult = ReturnType<typeof useVersionUpdateStepLazyQuery>;
export type VersionUpdateStepSuspenseQueryHookResult = ReturnType<typeof useVersionUpdateStepSuspenseQuery>;
export type VersionUpdateStepQueryResult = ApolloReactCommon.QueryResult<VersionUpdateStepQuery, VersionUpdateStepQueryVariables>;